const INITIAL_STATE = {
    show: false
};

export function reducer(state = INITIAL_STATE, action) {
    if (action.type === "TOGGLE_SETTINGS_MENU") {
        return {...state, show: action.payload.show}
    } else if (action.type.startsWith("SUBSCRIPTION_ENDED")) {
        return INITIAL_STATE;
    } else {
        return state;
    }
}

function toggleSettingsMenu(show) {
    return {type: "TOGGLE_SETTINGS_MENU", payload: {show}}
}

export default dispatch => ({
    toggleSettingsMenu(show) {
        dispatch(toggleSettingsMenu(show));
    }
});
